import * as React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Top from "../Top";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import { FormControl, FormControlLabel, InputLabel, MenuItem, Modal, Radio, RadioGroup, Select, Typography } from '@mui/material';
import { FormContainer, PasswordElement, PasswordRepeatElement, set, TextFieldElement } from "react-hook-form-mui";

import ApartmentIcon from '@mui/icons-material/Apartment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import WcIcon from '@mui/icons-material/Wc';
import FaceIcon from '@mui/icons-material/Face';
import Face4Icon from '@mui/icons-material/Face4';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import api from "../../utils/api";
import * as util from "../../utils/util";

const typeSaveBasicParam = {
  id: '', code: '',  companyId: '', type: '', userName: '', birthDate: '', cusId: '', phone: '', address: '', buildingNum: ''
  , email: '', zipCode: '', beforePassword: '', afterPassword: '', afterPasswordCheck: ''
};

const OfficeJoinCompanyCheck = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = { ...location.state };
  const [saveBasicParam, setSaveBasicParam] = React.useState(typeSaveBasicParam);
  const [isCompanyIdCheck, setIsCompanyIdCheck] = React.useState(false);
  const [companyId, setCompanyId] = React.useState('');
  const [type, setType] = React.useState('');
  const [code, setCode] = React.useState('');

  useEffect(() => {
    setSaveBasicParam(userInfo);
  }, []);


  // 회원 추가정보를 받기 위한 화면으로 이동
  async function handleSaveUser(data: any) {
    if (!isCompanyIdCheck) {
      alert('기업코드 확인을 해주세요.');
    } else {
      const updatedProfile = {
        ...saveBasicParam,
        companyId: companyId,
        type: type,
      };

      navigate('/Join/OfficeJoinPrivate', { state: updatedProfile });
    }
  }

  function isCode(text: any) {
    return ((/[^019GILOS]/ig).test(text) && (/^[\d\S]{6}$/ig).test(text));
  }

  return (
    <Container sx={Logbg}>
      <Top title="회원 가입" />

      <Stack direction={'column'} sx={{ justifyContent: 'center', alignContent: 'center' }}>
        <FormContainer
          values={{ code: code }}
          onSuccess={data => handleSaveUser(data)}
        >

          <Card sx={{ p: '0px 20px 30px 20px', bgcolor: '#fff' }}>
            <Divider sx={{ fontSize: 18, mb: 2, mt: 2.5, fontWeight: 700 }}>기업 확인</Divider>

            <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2, width: '100%' }}>
              <ApartmentIcon sx={profileIcon} />
              <TextFieldElement
                name="code"
                id="input-code" label="기업코드" variant="standard"
                fullWidth
                rules={{
                  required: '필수 입력입니다.',
                }}
                onChange={(e: any) => {
                  setSaveBasicParam((prev) => true ? { ...prev, code: e.target.value } : prev);
                  setCode(e.target.value);
                }}
                sx={loginField}
                inputProps={{ readOnly: isCompanyIdCheck }}
              />
              <Button onClick={() => {
                if (!isCompanyIdCheck) {
                  if (util.strNull(code) !== '') {
                    if (!isCode(code)) {
                      alert('기업코드 형식을 확인해주세요.');
                    } else {
                      api.get('permission/companies/check', { params: { code: code, name: '', birthDate: '' } }).then(res => {
                        setIsCompanyIdCheck(res.data.success);
                        if (!res.data.success) {
                          alert(res.data.message);
                        } else {
                          setCompanyId(res.data.data.id);
                          setType(res.data.data.type)
                          alert('기업코드 확인되었습니다.');
                        }
                      }).catch(function (error) {
                        console.log(error);
                      });
                    }
                  } else {
                    alert('기업코드 입력 후 시도해주세요.');
                  }
                } else {
                  alert('기업코드 확인되었습니다.');
                }
              }} sx={{ display: 'flex', fontSize: 12, minWidth: 70, border: '1px solid #ed6c02', borderRadius: 20, color: '#ed6c02', bgcolor: '#ed6c0214', fontWeight: 700, p: .5 }}>
                코드확인
              </Button>
            </Box>

          </Card>

          <Box sx={{ p: '10px 0px 30px 0px' }}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ mt: 3, bgcolor: '#ffb068', borderRadius: '20px' }}>
              {/* <CareButton variant="contained" sx={{ bgcolor: '#FFB068', color: '#fff' }} onClick={() => navigate('../Join/Join')} >
                취소
              </CareButton> */}

              <CareButton variant="contained" type={'submit'}>
                다음
              </CareButton>
            </Stack>
          </Box>
        </FormContainer>

      </Stack>

    </Container>
  );
}

const profileIcon = {
  color: '#888', mr: 1, my: 0.5, fontSize: 20
}

const CareButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 30px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  borderColor: '#EF8322',
  borderRadius: '20px',
  width: '100%',
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});

const loginField = {
  '& input': {
    fontSize: 15
  },
  '& label': {
    color: '#888',
    fontSize: 16,
    transform: 'translate(0, -1.5px) scale(0.75)'
  },
  '& label.Mui-focused': {
    color: '#ef8322',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#ef8322',
  },
  '& .MuiInputBase-root:before': {
    borderBottomColor: '#bbb',
  }
};

const Logbg = {
  bgcolor: '#f6f6f6',
  height: '100%',
  minHeight: '100vh',
  pb: 4,
  minWidth: '320px',
  pt: 10,
}

export default OfficeJoinCompanyCheck;